import { useMemo } from "react";
import { useQuantities } from "./useQuantities";
import { withKeyNotNull } from "diagnostics-lib/typescript";
const usePerformanceIndicators = (projectId: string) => {
  const quantities = useQuantities(projectId);

  const performanceIndicators = useMemo(
    () =>
      quantities
        .filter(withKeyNotNull("qoiOrder"))
        .sort((a, b) => (a.qoiOrder! < b.qoiOrder! ? -1 : 1)),
    [quantities],
  );

  return performanceIndicators;
};

export const useActivePowerPerformanceIndicator = (projectId: string) => {
  const performanceIndicators = usePerformanceIndicators(projectId);
  return performanceIndicators.find(pi => pi.qoiRole === "POWER") ?? null;
};

export default usePerformanceIndicators;

export type PerformanceIndicator = ReturnType<typeof usePerformanceIndicators>[number];
